import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type TWeekScheduleInfo = { title: string, weeks: number, weekTime: number };

interface IAuxScheduleState {
  weekSchedule: TWeekScheduleInfo | null;
  setWeekSchedule: (data: TWeekScheduleInfo | null) => void
}

export const useAuxScheduleStore = create<IAuxScheduleState>()(persist((set) => ({
  weekSchedule: null,
  setWeekSchedule: (data: TWeekScheduleInfo | null) => set({ weekSchedule: data })
}), { name: 'AuxScheduleState' }))
